export default "__VITE_ASSET__DkBp6RUi__"